<script setup>
import { defineProps } from "vue";

const props = defineProps({
  errors: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <div class="mb-4" v-if="props.errors.length > 0 && props.errors[0] !== null">
    <div class="font-medium text-danger">Whoops! Something went wrong.</div>
    <ul class="mt-3 list-disc text-sm text-danger pl-4">
      <li v-for="(error, index) in props.errors" :key="index">{{ error }}</li>
    </ul>
  </div>
</template>
